"use strict";
import "./plugins/pallycon-fairplay-support.js";
import './node_contains.js';
import '../stylesheets/playback.scss';

if (typeof window.playback === "undefined") { window.playback = {}; }

window.playback.Timing = require("./utils/timing").Timing;
window.playback.Player= require("./player").Player;